// src/components/LiensLegaux.jsx
// ─────────────────────────────────────────────────────────────
// Liens de bas de page vers les mentions légales et la politique
// de confidentialité. À placer en fin de chaque page publique.
// ─────────────────────────────────────────────────────────────
import React from 'react';
import { Link } from 'react-router-dom';
import '../pages/PagesLegales.css';
import SelecteurLangue from './SelecteurLangue';
import { useTextes } from '../i18n/Langue';

const textes = {
  fr: {
    titre: 'Informations légales',
    mentions: 'Mentions légales',
    confidentialite: 'Politique de confidentialité',
  },
  en: {
    titre: 'Legal information',
    mentions: 'Legal notice',
    confidentialite: 'Privacy policy',
  },
};

function LiensLegaux() {
  const t = useTextes(textes);
  return (
    <nav className="liens-legaux" aria-label={t.titre}>
      <span>© Le Chalet des Flandres</span>
      <Link to="/mentions-legales">{t.mentions}</Link>
      <Link to="/confidentialite">{t.confidentialite}</Link>
      <SelecteurLangue />
    </nav>
  );
}

export default LiensLegaux;
